<!-- ADD TO TRUCK MODAL -->
<template>
  <b-modal
    :id="modalName"
    size="xl"
    role="document"
    title="Remove Selected Order from Truck"
    v-model="modalIsVisible"
    @show="load"
    @hide="unload"
    ><div v-if="loading" class="text-center">
      <b-spinner>Loading...</b-spinner> Loading
    </div>
    <div v-else>
      <div>
        <b-alert
          v-if="
            ordersWithMissingShipsWithOrders &&
            ordersWithMissingShipsWithOrders.length > 0
          "
          variant="warning"
          show
        >
          <div
            v-for="missingShipsWithOrder in ordersWithMissingShipsWithOrders"
            :key="missingShipsWithOrder.headerNumber"
          >
            Ships with Orders not being added with order #{{
              missingShipsWithOrder.headerNumber
            }}
            -
            <span
              v-for="(
                headerNumber, index
              ) in missingShipsWithOrder.missingShipsWithOrderNumbers"
              :key="index"
              ><a href="#" @click="addOrder(headerNumber)">{{ headerNumber }}</a
              ><span
                v-if="
                  index !=
                  missingShipsWithOrder.missingShipsWithOrderNumbers.length - 1
                "
                >,
              </span></span
            >
            (<a
              href="#"
              @click="addAllShipsWithOrders(missingShipsWithOrder.headerNumber)"
              >Add All</a
            >)
          </div>
        </b-alert>
        <p>The following orders will be removed from their truck</p>
        <p v-for="order in orders" :key="order.number">
          <strong class="d-inline-block mb-3">System #:&nbsp;</strong>
          {{ order.headerNumber }}
          <strong class="d-inline-block mb-3">CRN:&nbsp;</strong>
          {{ order.crn }}
          <strong class="d-inline-block mb-3">Facility:&nbsp;</strong>
          {{ order.facility || order.facilityCode }}
          <strong class="d-inline-block mb-3"
            >Scheduled Delivery Date:&nbsp;</strong
          >
          {{ formatDate(order.scheduledDeliveryDate) }}
          <strong class="d-inline-block mb-3">Truck:&nbsp;</strong>
          {{ order.truckInfo ? order.truckInfo.truckName : "" }}
        </p>
      </div>
    </div>
    <template v-slot:modal-footer class="justify-content-center">
      <b-button variant="primary" @click="removeFromTruck"> Remove </b-button>
      <b-button variant="primary" @click="hideModal"> Close </b-button>
    </template>
  </b-modal>
</template>
<!-- END ADD TO TRUCK MODAL -->
<script>
import { formatDate } from "../../../utils";
import { mapActions, mapState } from "vuex";
import TruckOrderViewModal from "../../../components/widgets/Modals/TruckOrderViewModal";
import mixin from "./mixin";
import * as modals from "../../../lib/modals";

export default {
  name: modals.removeOrderFromTruckModal,
  mixins: [mixin],
  components: {
    TruckOrderViewModal,
  },
  data() {
    return {
      orders: [],
      loading: false,
      previewResults: [],
      removing: false,
    };
  },
  computed: {
    ...mapState({
      truckData: (state) => state.truck.data,
    }),
    ...mapState("order", {
      orderData: (state) => state.data,
    }),
    ordersWithMissingShipsWithOrders() {
      return this.orders.filter(
        (x) =>
          x.missingShipsWithOrderNumbers &&
          x.missingShipsWithOrderNumbers.length > 0
      );
    },
  },
  methods: {
    pushOrder(order) {
      let previewOrder = this.previewResults.find(
        (x) => x.orderHeaderNumber == order.headerNumber
      );
      this.orders.push({
        headerNumber: order.headerNumber,
        crn: order.crn,
        facility: order.facility || order.facilityCode,
        scheduledDeliveryDate: order.scheduledDeliveryDate,
        missingShipsWithOrderNumbers:
          previewOrder.missingShipsWithHeaderNumbers,
        truckInfo: previewOrder.truckInfo,
      });
      var ordersWithMissingShipsWithHeaderNumbers =
        this.ordersWithMissingShipsWithOrders.filter(
          (x) => x.missingShipsWithOrderNumbers.indexOf(order.headerNumber) > -1
        );
      for (
        let index = 0;
        index < ordersWithMissingShipsWithHeaderNumbers.length;
        index++
      ) {
        let shipsWithOrder = ordersWithMissingShipsWithHeaderNumbers[index];
        let removeIndex = shipsWithOrder.missingShipsWithOrderNumbers.indexOf(
          order.headerNumber
        );
        shipsWithOrder.missingShipsWithOrderNumbers.splice(removeIndex, 1);
      }
    },

    async updatePreviewResults() {
      const request = {
        orderNumbers: this.selectedItems.map((x) => x.headerNumber || x.number),
      };

      this.previewResults = [];
      try {
        this.previewResults = await this.previewAddOrderToTruck(request);
      } catch (ex) {
        this.addActionResult({
          number: this.selectedItems[i].number,
          success: false,
          message: `Failed to add to truck. Failed to retreive ships with order information.`,
        });
        return;
      }
    },
    async load() {
      this.orders = [];
      this.show();

      await this.updatePreviewResults();
      for (var i = 0; i < this.selectedItems.length; i++) {
        this.pushOrder(this.selectedItems[i]);
      }
    },
    unload() {
      this.orders = [];
      this.trucks = [];
    },
    async removeFromTruck() {
      this.removing = true;
      for (let x = 0; x < this.orders.length; x++) {
        await this.doRemoveOrderFromTruck(this.orders[x]);
      }
      this.removing = false;
      await this.refreshOrders();
      this.hideModal();
    },
    async doRemoveOrderFromTruck(selectedOrder) {
      if (selectedOrder.truckInfo && selectedOrder.truckInfo.id != null) {
        let action = {
          orderId: selectedOrder.truckInfo.truckDetailId,
          truckId: selectedOrder.truckInfo.id,
        };
        try {
          await this.removeOrderFromTruck(action);
          this.addActionResult({
            number: selectedOrder.headerNumber,
            success: true,
            message: `Order ${selectedOrder.headerNumber} removed from truck ${selectedOrder.truckInfo.truckName}.`,
          });
        } catch (error) {
          this.addActionResult({
            number: selectedOrder.headerNumber,
            success: false,
            message: error.response.data.message,
            errors:
              error.response.data && error.response.data.errors
                ? error.response.data.errors
                : null,
            errorMessages:
              error.response.data && error.response.data.errorMessages
                ? error.response.data.errorMessages
                : null,
          });
        }
      }
    },
    formatDate(value) {
      return formatDate(value);
    },
    async addOrder(headerNumber) {
      if (this.orders.filter((x) => x.headerNumber == headerNumber).length > 0)
        return;

      this.loading = true;

      var getOrdersRequest = {
        orderNumber: headerNumber,
        pageNumber: 1,
        pageSize: 1,
      };

      let response = await this.getOrders(getOrdersRequest);

      if (response.items && response.items.length > 0) {
        let selectedItem = response.items.map((x) => ({
          headerNumber: x.headerNumber,
          crn: x.crn,
          scheduledDeliveryDate: x.scheduledDeliveryDate,
        }))[0];

        if (
          this.selectedItems.filter(
            (x) => x.headerNumber == selectedItem.headerNumber
          ).length == 0
        )
          this.addSelectedItem(selectedItem);

        await this.updatePreviewResults();
        this.loading = false;

        this.pushOrder(selectedItem);
      }
    },
    async addAllShipsWithOrders(headerNumber) {
      if (this.orders.filter((x) => x.headerNumber == headerNumber).length < 1)
        return;

      var addedOrders = [];

      this.loading = true;

      var getOrdersRequest = {
        shipsWithOrderNumber: headerNumber,
        pageNumber: 1,
        pageSize: 200,
      };

      let response = await this.getOrders(getOrdersRequest);

      if (response.items && response.items.length > 0) {
        for (var i = 0; i < response.items.length; i++) {
          let selectedItem = response.items.map((x) => ({
            headerNumber: x.headerNumber,
            crn: x.crn,
            facility: x.facilityCode || x.facility,
            scheduledDeliveryDate: x.scheduledDeliveryDate,
          }))[i];

          if (
            this.orders.filter(
              (x) => x.headerNumber == selectedItem.headerNumber
            ).length == 0
          ) {
            addedOrders.push(selectedItem);

            if (
              this.selectedItems.filter(
                (x) => x.headerNumber == selectedItem.headerNumber
              ).length == 0
            )
              this.addSelectedItem(selectedItem);
          }
        }

        if (addedOrders && addedOrders.length > 0) {
          await this.updatePreviewResults();
          this.loading = false;

          for (var i = 0; i < addedOrders.length; i++) {
            this.pushOrder(addedOrders[i]);
          }
        }
      }
    },
    ...mapActions("truck", {
      removeOrderFromTruck: "removeOrderFromTruck",
      previewAddOrderToTruck: "previewAddOrderToTruck",
    }),
    ...mapActions("order", {
      getOrders: "getOrders",
    }),
  },
};
</script>
